<template>
  <li class="menu-item">
    <a @click="navigate($event)" :class="isActive()" :data-tooltip="name" data-tooltip-position="right">
      <LucideIcon v-if="icon" :icon="icon" />
      <img v-if="svg"  :src="$image(`assets/${svg}`)"/>
    </a>
  </li>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MenuItemElement',
  props: {
    name: {
      type: String,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    svg: {
      type: String,
      required: true,
    },
  },
  methods: {
    navigate(e: Event) {
      this.$router.push(this.path);
      e.preventDefault();
    },
    isActive(): {[key: string]: boolean} {
      const isActive = this.$route.fullPath === this.path;

      return {
        active: isActive,
      };
    },
  },
});

</script>
<style lang="scss" scoped>

  .menu-item {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    a{
      width: 50px;
      height: 50px;
      font-size: var(--fs-20);
      padding: 5px 10px;
      color: var(--text-dark);
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover{
        color: var(--text-dark);
        background-color: var(--neutral-100);
        border-radius: $br-circle;
      }
      &.active{
        color: var(--text-dark);
        background-color: var(--neutral-100);
        border-radius: $br-circle;
      }
    }
  }

</style>
